<template>
  <div class="section_wrap">
    <h6 class="--blue70">
      {{$t('report.components.no_select.name')}}
    </h6>
    <div class="section_body">
			{{$t('report.components.no_select.context')}}
    </div>
  </div>
</template>
<script>
    export default {
      name: "NoSelection",
      props: ['patientInfoProps'],
    }
</script>
<style lang="scss">
</style>